import { sliderFace } from "@/components/input/custom/pain-slider/sliderFace";
import { cn } from "@/lib/utils";
import type { BaseEntryValueProps } from "./BaseEntryValue";
import { BaseEntryValue } from "./BaseEntryValue";

export interface PainSliderEntryValueProps extends Omit<BaseEntryValueProps, "value"> {
    value: number | null;
}

export function PainSliderEntryValue({ value, inputLabel, size, className, ...props }: PainSliderEntryValueProps) {
    const numericValue = value !== null && value !== undefined ? Number(value) : null;
    const { icon, message } = sliderFace(numericValue ?? 0);
    const isCompact = size === "sm" || size === "md";

    if (isCompact) {
        return (
            <BaseEntryValue inputLabel={inputLabel} className={cn("py-0", className)} size={size} {...props}>
                <p
                    className={cn(
                        "text-slate-900 dark:text-slate-200 leading-snug",
                        size === "sm" ? "text-sm" : "text-md"
                    )}
                >
                    <span className="font-semibold tabular-nums">
                        {numericValue != null ? `${numericValue}/10` : "–"}
                    </span>
                    {message ? <span className="font-normal text-muted-foreground"> · {message}</span> : null}
                </p>
            </BaseEntryValue>
        );
    }

    return (
        <BaseEntryValue inputLabel={inputLabel} className={className} size={size} {...props}>
            <div className="flex items-center gap-3">
                <div
                    className={cn(
                        "flex justify-center items-center shrink-0",
                        size === "lg" ? "w-12 h-12" : "w-10 h-10"
                    )}
                >
                    {icon}
                </div>
                <div>
                    <p className={cn("font-semibold tabular-nums", size === "lg" ? "text-xl" : "text-base")}>
                        {numericValue != null ? `${numericValue}/10` : "–"}
                    </p>
                    <p className={cn("text-muted-foreground", size === "lg" ? "text-sm" : "text-sm")}>{message}</p>
                </div>
            </div>
        </BaseEntryValue>
    );
}
